import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DataStorageService } from '../data-storage.service';

@Component({
  selector: 'app-dialog-select-side',
  templateUrl: './dialog-select-side.component.html',
  styleUrls: ['./dialog-select-side.component.css']
})
export class DialogSelectSideComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogSelectSideComponent>,
    private translate: TranslateService,
    private dataStorage: DataStorageService) {
      translate.setDefaultLang('en');
      translate.use(dataStorage.getLanguage());
    
  }

  ngOnInit() {

  }

  chooseSide(side: string) {
    this.dialogRef.close(side);
  }

}



// WEBPACK FOOTER //
// ./src/app/dialog-select-side/dialog-select-side.component.ts